import { DayHours } from '@models/day-hours.model';
import { NotificationsService } from '@services/services.module';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ImputationsData } from '@components/calendar/calendar-day/calendar-day.model';
import { TranslateService } from '@ngx-translate/core';
import { RangeHourService } from '@services/range-hour/range-hour.service';
import { UtilsService } from '@services/utils/utils.service';
@Component({
  selector: 'app-filas-modal-s2-s3',
  templateUrl: './filas-modal-s2-s3.component.html',
  styleUrls: ['./filas-modal-s2-s3.component.scss']
})
export class FilasModalS2S3Component implements OnInit {

  dayHours: DayHours[];
  @Input() rowData: ImputationsData;
  @Output() update: EventEmitter<any> = new EventEmitter();
  @Output() delete: EventEmitter<any> = new EventEmitter();

  public startTime: Date;
  public endTime: Date;
  public endTimeChanged: boolean;

  constructor(
    private notification: NotificationsService,
    public translate: TranslateService,
    public rangeHourService: RangeHourService,
    public utilsService: UtilsService
  ) { }

  ngOnInit() {
    // transformamos la data, para poder trabajar con ella
    if (this.rowData.endTime === '00:00:00') {
      this.rowData.endTime = '24:00:00';
    }
    if (this.rowData.startTime) {
      this.startTime = new Date();
      this.startTime.setHours(Number(this.getHH(this.rowData.startTime)));
      this.startTime.setMinutes(Number(this.getMM(this.rowData.startTime)));
      this.startTime.setSeconds(Number(this.getSS(this.rowData.startTime)));
    }

    if (this.rowData.endTime) {
      this.endTime = new Date();
      this.endTime.setHours(Number(this.getHH(this.rowData.endTime)));
      this.endTime.setMinutes(Number(this.getMM(this.rowData.endTime)));
      this.endTime.setSeconds(Number(this.getSS(this.rowData.endTime)));
    }

    // llenamos la array de horas
    this.dayHours = this.rangeHourService.newArrayHours();

    if (this.rowData.startTime && this.rowData.endTime) {
      this.rowData.hours = this.utilsService.diffHours(this.startTime, this.endTime);
    }

    if (this.rowData.hours) {
      this.rowData.hours = Number(this.rowData.hours).toFixed(1);
    }
    // this.update.emit(this.rowData);
  }

  deleterow(data) {
    this.delete.emit(data);
  }

  insertProject(proyectData): void {
    this.rowData.projectId = proyectData.Id;
    this.rowData.sapId = proyectData.name;

    this.update.emit(this.rowData);
  }

  deleteProject() {
    this.rowData.projectId = '';
    this.rowData.sapId = '';

    this.update.emit(this.rowData);
  }

  changeData(rowData): void {
    if (this.rowData.hours) {
      this.rowData.hours = Number(this.rowData.hours).toFixed(1);
    }
    this.update.emit(rowData);
  }

  hourChanged() {
    if (this.rowData.startTime) {
      this.startTime = new Date();
      this.startTime.setHours(Number(this.getHH(this.rowData.startTime)));
      this.startTime.setMinutes(Number(this.getMM(this.rowData.startTime)));
      this.startTime.setSeconds(Number(this.getSS(this.rowData.startTime)));
    }

    if (this.rowData.endTime) {
      this.endTime = new Date();
      this.endTime.setHours(Number(this.getHH(this.rowData.endTime)));
      this.endTime.setMinutes(Number(this.getMM(this.rowData.endTime)));
      this.endTime.setSeconds(Number(this.getSS(this.rowData.endTime)));
    }

    if (this.startTime && this.endTime) {

      this.rowData.hours = (this.utilsService.diffHours(this.startTime, this.endTime));
      if (this.rowData.hours) {
        this.rowData.hours = Number(this.rowData.hours).toFixed(1);
      }
      if (this.startTime.getTime() >= this.endTime.getTime()) {
        this.notification.setWarning(this.translate.instant('CALENDARIO.HR_ENTR'));
        this.rowData.hours = -this.rowData.hours;
      }

      this.update.emit(this.rowData);

    }

  }

  numberToString(data) {
    if (data.toString().length === 1) {
      return '0' + data;
    } else {
      return data;
    }
  }

  private getHH(fecha): string {
    return fecha.substring(0, 2);
  }

  private getMM(fecha): string {
    return fecha.substring(3, 5);
  }

  private getSS(fecha): string {
    return fecha.substring(6, 8);
  }

}
